import React, { Component } from 'react';
// Importa connect per connettere il componente al redux
import { connect } from 'react-redux';
import * as actions from '../../reducers/actions/Auth';
import { Redirect } from 'react-router-dom';

// Importa componenti Bootstrap
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
// import './style.scss'; // npm install --save node-sass for use Scss

class SignIn extends Component {

    state = {
        nickname: "",
        password: ""
    }

    // On Form-Text Change
    valueChangeHandler = (evt) => {
        let id = evt.target.id;
        let value = evt.target.value;
        // imposta i cambiamenti in base al chiave valore id: value
        this.setState({
            [id]: value
        });
    }

    onSubmitHandler = (evt) => {
        evt.preventDefault();
        // console.log("[ACTION] Submit Form Login");
        // Invoca la Action dichiarata nel reducer
        // passa la action al reducer
        this.props.onAuth(this.state.nickname, this.state.password); // chiama la funzione presente nel reducer e passa email e password
    }

    onLogoutHandler = (evt) => {
        evt.preventDefault();
        // console.log("Logout Button Clicked");

        this.props.onLogout(); // chiama la funzione Logout dal reducer
    }
    
    render() {

        // SE L'UTENTE HA UN TOKEN SIGNIFICA CHE È LOGGATO, QUINDI MOSTRA UN BOTTONE DI LOGOUT
        // let dataLogin = null;
        // Prendi i dati salvati nel reducer
        if (this.props.isAuthenticated) {
            /* Se si è loggati allora spostati nella sezione admin */
            return <Redirect to="/admin" />;
            /*
            dataLogin = <center>
                <p>YOUR TOKEN: {this.props.token}</p>
                <p>User Id: {this.props.userId}</p>
                <p>IS AUTHENTICATED: {this.props.isAuthenticated ? "true" : "false"}</p>
                <Button onClick={(e) => this.onLogoutHandler(e)}>LOGOUT</Button>
                <p></p>
            </center>
            */
        }

        let alertError = null;
        if(this.props.error !== null) {
            // console.log("PAssword errata");
            alertError = <Alert variant="danger">Nickname or Password wrong!</Alert>;
        }

        return(
            
            <Container>
                <br/>
                { alertError }
                <Row>
                    <Col><h3>Wallpapers Panel</h3></Col>
                </Row>
                <Row>
                    <Col>
                        <Form onSubmit={this.onSubmitHandler}>
                            <Form.Group controlId="nickname">
                                <Form.Label>Nickname</Form.Label>
                                <Form.Control type="text" placeholder="Enter Nickname" value={this.state.nickname} onChange={(e) => this.valueChangeHandler(e)} />
                            </Form.Group>

                            <Form.Group controlId="password">
                                <Form.Label>Password</Form.Label>
                                <Form.Control type="password" placeholder="Password" value={this.state.password} onChange={(e) => this.valueChangeHandler(e)} />
                            </Form.Group>
                            <Button variant="primary" type="submit">Login</Button>
                        </Form>
                    </Col>

                </Row>
            </Container>
        );
    }
}

// Mappa come props lo state del reducer
const mapStateToProps = state => {
    return {
        loading: state.auth.loading, // accedi allo stato del reducer auth! => vedi file index.js in cui combino i vari reducer quindi accedi al loading di auth
        error: state.auth.error,
        isAuthenticated: state.auth.token !== null,
        token: state.auth.token,
        userId: state.auth.userID
    };
};

// Mappa come props le action Presenti nel reducer
const mapDispatchToProps = dispatch => {
    return {
        onAuth: (email, password) => dispatch(actions.auth(email, password)), // chiama la funzione presente nel reducers/actions/Auth.js
        onLogout: () => dispatch(actions.logout()) // chiama la funzione logout dall reducer Auth
    };
};

// passa null come proprietà state to Props visto che non abbiamo qualcosa da passare (non ci serve) e passa le action
export default connect(mapStateToProps, mapDispatchToProps)(SignIn);